import axiosInstance from './util/auth_util'

const CollService = {
  // 更改收藏夾狀態
  async changeColl(formData) {
    try {
      const response = await axiosInstance.post('/collect/change', formData, {
        headers: {
            'Content-Type': 'multipart/form-data', // 显式设置表单类型
        },
      })
      return response.data
    } catch (error) {
      console.error('添加收藏夾失敗:', error.response.data.detail)   
      throw error.response.data.detail || '添加失敗'
    }
  },

  // 獲取收藏夾
  async getColl() {
    try {
      const response = await axiosInstance.get('/collect/get')
      return response.data
    } catch (error) {
      console.error('獲取收藏夾失敗:', error)
      throw error
    }
  },

  // 刪除收藏夾
  async deleteColl(GoodsID) {
    try {
      const response = await axiosInstance.delete(`/collect/delete/${GoodsID}`)
      return response.data
    } catch (error) {
      console.error('刪除失敗:', error)
      throw error
    }
  },

  // 獲取當前商品收藏夾狀態
  async getCollstatus(GoodsID) {
    try {
      const response = await axiosInstance.get(`/collect/status/${GoodsID}`)
      return response.data
    } catch (error) {
      console.error('刪除失敗:', error)
      throw error
    }
  },

  // 獲取收藏信息
  async getCollState(GoodsID, quantity){
      try{
          const response = await axiosInstance.post(`/collect/update`, { GoodsID, quantity })
          return response; 
      } catch(error){
          console.log(error)
          throw error;
      }
  },

}

export default CollService